import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Chrome } from 'lucide-react';
import { AuthFrame } from '../../components/AuthFrame';
import { requireSupabase } from '../../lib/supabase';

export function SignupPage() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault(); setBusy(true); setMessage('');
    const { error } = await requireSupabase().auth.signUp({
      email,
      password,
      options: {
        data: { full_name: fullName },
        emailRedirectTo: `${window.location.origin}/hub/onboarding`,
      },
    });
    setBusy(false);
    setMessage(error ? error.message : 'Check your email to verify your account and claim access.');
  };

  const google = async () => {
    const { error } = await requireSupabase().auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/hub/onboarding` },
    });
    if (error) setMessage(error.message);
  };

  return (
    <AuthFrame eyebrow="Create your account" title="Enter the Rebuild Hub" description="One account. Four rebuilds. Your purchases determine what opens." footer={<p>Already have an account? <Link to="/hub/login">Sign in</Link></p>}>
      <form className="auth-form" onSubmit={submit}>
        <label>Full name<input value={fullName} onChange={(e) => setFullName(e.target.value)} required /></label>
        <label>Email<input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        <label>Password<input type="password" minLength={8} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        {message && <div className="form-message">{message}</div>}
        <button className="button primary full" disabled={busy}>{busy ? 'Creating account…' : <>Create account <ArrowRight size={17} /></>}</button>
        <button type="button" className="button secondary full" onClick={google}><Chrome size={17} /> Continue with Google</button>
      </form>
    </AuthFrame>
  );
}
